var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
var FooterPoweredBy = /** @class */ (function (_super) {
    __extends(FooterPoweredBy, _super);
    function FooterPoweredBy() {
        var _this = _super.call(this) || this;
        var poweredByText = "".concat(process.env.AIGO_CHAT_FOOTER_POWERED_BY_TEXT);
        var footerText = document.createElement('div');
        footerText.id = 'js_aigo_bot_footer_powered_by';
        footerText.innerHTML = poweredByText;
        footerText.style.paddingBottom = '5px';
        footerText.style.paddingRight = '9px';
        footerText.style.textAlign = 'right';
        footerText.style.fontSize = '10px';
        _this.self = footerText;
        return _this;
    }
    return FooterPoweredBy;
}(Base));
export { FooterPoweredBy };
